import { http, HttpResponse, type HttpHandler } from "msw";
import mockProjects from "./mockProjects";
import mockImpact from "./mockImpact";
import mockClient from "./mockClient";
import mockinvestments from "./mockInvestments";

export const fullyQualifiedURL = (path: string) => {
  return new URL(path, import.meta.env.VITE_BACKEND_BASE_URL).toString();
};

const handlers: Array<HttpHandler> = [
  http.get(fullyQualifiedURL("/v3/:clientId"), () =>
    HttpResponse.json(mockClient, { status: 200 }),
  ),
  http.get(fullyQualifiedURL("/v3/:clientId/impact"), () =>
    HttpResponse.json(mockImpact, { status: 200 }),
  ),
  http.get(fullyQualifiedURL("/v3/:clientId/projects"), () =>
    HttpResponse.json(mockProjects, { status: 200 }),
  ),
  http.get(fullyQualifiedURL("/v3/:clientId/investments"), () =>
    HttpResponse.json(mockinvestments, { status: 200 }),
  ),
];

export default handlers;
